const services = {
    //--------------------------------------------------API--------------------------------------------------//
    getCentros:                            '/api/centros', //pendiente
    apiStatus:                             '/api/status',
    logJobs:                               '/api/jobs-logs/status-jobs',
    //----------------------------------------BANNERS------------------------------------------------//
    postMultipleSkuesProduct:              '/v2/banner/create',
    getAllBanners:                         '/v2/banner/pagination',
    deleteBanner:                          '/v2/banner/',
    updateBanner:                          '/v2/banner/update',
    //----------------------------------------CATEGORIAS------------------------------------------------//
    deactivateCategories:                  '/v2/categories/deactivate/',
    activateCategories:                    '/v2/categories/activate/',
    updateCategories:                      '/v2/categories/update',
    deleteCategories:                      '/v2/categories/delete/',
    getCategories:                         '/v2/categories/categoriesWithSubcategories',
    addCategories:                         '/v2/categories/create',
    //----------------------------------------CENTROS------------------------------------------------//
    centersWithoutOpenPay:                 '/v2/center/getWithoutOpenPay',
    getCentersByPaginator:                 '/v2/center/pagination',
    centersWithOpenPay:                    '/v2/center/getWithOpenPay',
    refactInnerBranch:                     '/v2/center/refactorInnerBrachId',
    updateAssociation:                     '/v2/center/updateAssociationOpenPay',
    associateOpenPay:                      '/v2/center/associateOpenPay',
    updateCenter:                          '/v2/center/update',
    deleteCenter:                          '/v2/center/delete?centroId=',
    getCenters:                            '/v2/center/getByFilters',
    addCenter:                             '/v2/center/create',
    //--------------------------------------------------CENTER_CONFIGURATION--------------------------------------------------//
    getCenterConfigurationByInnerBranchId: '/v2/center-configuration/getByInnerBranchId',
    updateCenterConfiguration:             '/v2/center-configuration/update',
    //--------------------------------------------------Deny--------------------------------------------------//
    getDenyByFilters:                      '/v2/deny',
    deactivateDeny:                        '/v2/deny/deactivate/',
    activateDeny:                          '/v2/deny/activate/',
    updateDeny:                            '/v2/deny/update',
    addDeny:                               '/v2/deny/create',
    //------------------------------------------------Faculty------------------------------------------------//
    getFacultyByFilters:                   '/v2/faculty',
    deactivateFaculty:                     '/v2/faculty/deactivate/',
    activateFaculty:                       '/v2/faculty/activate/',
    updateFaculty:                         '/v2/faculty/update',
    addFaculty:                            '/v2/faculty/create',
    //----------------------------------------FEATURED PRODUCTS------------------------------------------------//
    deactivateFeaturedProduct:             '/v2/featured-products/deactivate',
    updateFeaturedProducts:                '/v2/featured-products',
    featuredProducts:                      '/v2/featured-products',
    //----------------------------------------NOTIFICATIONS------------------------------------------------//
    updateNotifications:                   '/v2/notifications/update',
    createNotifications:                   '/v2/notifications/create',
    deleteNotifications:                   '/v2/notifications/delete',
    getNotifications:                      '/v2/notifications/get',
    //----------------------------------------OPENPAY------------------------------------------------//
    getOpenpayCredentials:                 '/v2/openpay/getCredentials',
    deleteAssociation:                     '/v2/openpay/deleteAssociation',
    //----------------------------------------PRODUCT_IMAGE_SAVED------------------------------------------------//
    productImageSaved:                     '/v2/product-image-saved',
    //----------------------------------------PRODUCTS------------------------------------------------//
    productsWithImages:                    '/v2/products/images/find-product-images/',
    productsDownload:                      '/v2/products/download/',
    markAsCompleted:                       '/v2/products/markAsImagesCompleted/',
    getAllProducts:                        '/v2/products/allProductBasicInfo/1',
    pendingImages:                         '/v2/products/find-pending-images-products',
    uploadImages:                          '/v2/products/upload-images',
    deleteImages:                          '/v2/products/images/delete-image/',
    //--------------------------------------------------ROL--------------------------------------------------//
    getRolByFilters:                       '/v2/rol',
    deactivateRol:                         '/v2/rol/deactivate/',
    activateRol:                           '/v2/rol/activate/',
    updateRol:                             '/v2/rol/update',
    addRol:                                '/v2/rol/create',
    //----------------------------------------SUBCATEGORIAS------------------------------------------------//
    deactivateSubcategories:               '/v2/subcategories/deactivate/',
    activateSubcategories:                 '/v2/subcategories/activate/',
    getSubcategoriesPag:                   '/v2/subcategories/pagination/',
    updateSubcategories:                   '/v2/subcategories/update',
    deleteSubcategories:                   '/v2/subcategories/delete/',
    getSubcategories:                      '/v2/subcategories/find',
    addSubcategories:                      '/v2/subcategories/create',
    //----------------------------------------USERS------------------------------------------------//
    updateUser:                            '/v2/user/update/',
    deleteUser:                            '/v2/user/delete/',
    getUsers:                              '/v2/user/get/',
    addUser:                               '/v2/user/create',
    login:                                 '/v2/user/loginV2',
    //--------------------------------------------------USER_CONFIGURATION--------------------------------------------------//
    getUserConfigurationById:              '/v2/user-configuration/getByUserId',
    updateUserConfiguration:               '/v2/user-configuration/update',
    //--------------------------------------------------ADDRESS_MANAGEMENT_PER_USER--------------------------------------------------//
    getSocialReasonDetail:                 '/v2/rfc/',
    getUserSocialReasons:                  '/v2/rfc/user/',
    getDeliveryAddresses:                  '/v2/sucursal/getWithAddressByRazonSocialId',
    updateSocialReason:                    '/v2/rfc',
    createSocialReason:                    '/v2/rfc/requestNewRfc',
    deleteSocialReason:                    '/v2/rfc/delete/',
    deactivateBranch:                      '/v2/sucursal/deactivate/',
    getBranchDetail:                       '/v2/sucursal/getBranchOffice',
    activateBranch:                        '/v2/sucursal/activate',
    createBranch:                          '/v2/sucursal/create',
    updateBranch:                          '/v2/sucursal/update',
}
export default services;